import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { MouseEventHandler, MutableRefObject } from 'react';
import { tw } from 'twind';
import { useCartStore } from 'store/cart';

export const Modal: React.FC<{
  open: boolean;
  requestClose: () => void;
  initialFocus?: MutableRefObject<null>;
  children: React.ReactNode;
}> = ({ open, requestClose, initialFocus, children }) => {
  const { theme } = useCartStore();

  const onXClick: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    requestClose();
  };

  return (
    <Transition.Root show={open}>
      <Dialog className={tw`fixed z-10 inset-0 overflow-y-auto`} initialFocus={initialFocus} onClose={() => {}}>
        <div className={tw`flex items-center justify-center min-h-screen pt-4 px-4 pb-20`}>
          <Transition.Child
            enter={tw`ease-out duration-300`}
            enterFrom={tw`opacity-0`}
            enterTo={tw`opacity-100`}
            leave={tw`ease-in duration-200`}
            leaveFrom={tw`opacity-100`}
            leaveTo={tw`opacity-0`}
          >
            <Dialog.Overlay className={tw`fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity`} />
          </Transition.Child>

          <Transition.Child
            enter={tw`ease-out duration-300`}
            enterFrom={tw`opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`}
            enterTo={tw`opacity-100 translate-y-0 sm:scale-100`}
            leave={tw`ease-in duration-200`}
            leaveFrom={tw`opacity-100 translate-y-0 sm:scale-100`}
            leaveTo={tw`opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`}
          >
            <div
              className={tw`relative inline-block align-bottom bg-white px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6`}
            >
              <div className={tw`absolute right-2 top-2 cursor-pointer`} onClick={onXClick}>
                <XIcon className={tw`h-5 w-5 aria-hidden="true text-${theme}-primary`} />
              </div>
              {children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
